import React, { useState, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RouteWrapper from "./Route";
import { PrivateRoute } from "./PrivateRoute";
import ResetPassword from "../pages/ResetPassword";
import SentMail from "../components/ForgotPassword/SentMail";
import SsoValidation from "../components/Sso";
import TestAssistantPageWrapper from "../pages/TestAssistantPageWrapper";
import TestSimulatorPageWrapper from "../pages/TestSimulatorPageWrapper";
import CategoryListPage from "../pages/Category Management";
import Provider from "../provider";
import Auth from "../utils/auth";
import UnAuthorized from "../pages/UnAuthorized";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const AdminDashboard = lazy(() => import("../pages/AdminDashboard"));
const KnowledgeBase = lazy(() => import("../pages/KnowledgeBase"));
const AssistantsPageWrapper = lazy(() =>
  import("../pages/AdminAssistantPageWrapper")
);
const KnowledgeBaseTableDetail = lazy(() =>
  import("../pages/KnowledgeBaseTableDetail")
);
const AssistantPageWrapper = lazy(() =>
  import("../pages/AssistantPageWrapper")
);
const BuildAssistantPageWrapper = lazy(() =>
  import("../pages/BuildAssistantWrapperPage")
);

const SimulatorPageWrapper = lazy(() =>
  import("../pages/SimulatorPageWrapper")
);

const BuildAssistantSimulatorPageWrapper = lazy(() =>
  import("../pages/BuildSimulatorWrapperPage")
);

const UseAssistantPageWrapper = lazy(() =>
  import("../pages/UseAssistantPageWrapper")
);
const UseSimulatorPageWrapper = lazy(() =>
  import("../pages/UseSimulatorPageWrapper")
);
const WorkflowPageWrapper = lazy(() => import("../pages/workflowPageWrapper"));
const Users = lazy(() => import("../pages/Users"));
const UpdateUser = lazy(() => import("../pages/UpdateUser"));
const SignIn = lazy(() => import("../pages/SignIn"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const ChatAssisstant = lazy(() =>
  import("../pages/ChatAssistant/ChatAssistant")
);
const ManageUsers = lazy(() => import("../pages/UsersManagement"));
const FileAnalyzer = lazy(() => import("../pages/FileAnalyzer"));
const ListAssistants = lazy(() => import("../pages/AssistantsList"));
const AddUser = lazy(() => import("../pages/AddUser"));
const PluginBuilder = lazy(() => import("../components/PluginBuilder"));
const HistoryDownload = lazy(() => import("../pages/HistoryDownload"));
const LinkedAssistants = lazy(() => import("../pages/LinkedAssistants"));
const AddOrganization = lazy(() => import("../pages/AddOrganization"));
const OrganizationListPage = lazy(() =>
  import("../pages/OrganizationManagement")
);
const WorkFlowBuilder = lazy(() =>
  import("../pages/Workflow/Workflow-builder")
);
const OneDriveRedirect = lazy(() => import("../pages/OneDriveRedirect"));

export default function RoutesPath() {
  const [email, setEmail] = useState({});

  return (
    <Routes>
      <Route
        path="/dashboard"
        element={<Navigate to="/dashboard/assistants" />}
      />
      <Route
        path="/dashboard/assistants"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/admin"
        element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Provider>
              <Users />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/users/:page/"
        element={
          <PrivateRoute>
            <Provider>
              <Users />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/categories"
        element={
          <PrivateRoute>
            <Provider>
              <CategoryListPage />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/file-analyzer"
        element={
          <PrivateRoute>
            <Provider>
              <FileAnalyzer />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/home/overview"
        element={
          <PrivateRoute>
            <Provider>
              <Dashboard />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/overview"
        element={
          <PrivateRoute>
            <Provider>
              <Dashboard />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route path="/dashboard/mainDashboard">
        <Route
          index
          element={
            <PrivateRoute>
              <Provider>
                <BuildAssistantPageWrapper />
              </Provider>
            </PrivateRoute>
          }
        />
        <Route
          path=":uuid"
          element={
            <PrivateRoute>
              <Provider>
                <BuildAssistantPageWrapper />
              </Provider>
            </PrivateRoute>
          }
        />
      </Route>
      <Route
        path="/dashboard/simulatorDashboard/:uuid?"
        element={
          <PrivateRoute>
            <Provider>
              <BuildAssistantSimulatorPageWrapper />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/assistant"
        element={
          <PrivateRoute>
            <AssistantPageWrapper />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/simulator"
        element={
          <PrivateRoute>
            <SimulatorPageWrapper />
          </PrivateRoute>
        }
      />
      <Route
        path="/assistants"
        element={
          <PrivateRoute>
            <Provider>
              <AssistantsPageWrapper />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/knowledgebase/tabledetail/:tableId"
        element={
          <PrivateRoute>
            <Provider>
              <KnowledgeBaseTableDetail />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/knowledgebase"
        element={
          <PrivateRoute>
            <Provider>
              <KnowledgeBase />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="dashboard/useassistant"
        element={
          <PrivateRoute>
            <UseAssistantPageWrapper />
          </PrivateRoute>
        }
      />
      <Route
        path="assistant/usesimulate"
        element={
          <PrivateRoute>
            <UseSimulatorPageWrapper />
          </PrivateRoute>
        }
      />
      <Route
        path="/assistant/chat"
        element={
          <PrivateRoute>
            <Provider>
              <ChatAssisstant />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/assistant/test"
        element={
          <PrivateRoute>
            <Provider>
              <TestAssistantPageWrapper />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/assistant/launch"
        element={
          <PrivateRoute>
            <Provider>
              <TestAssistantPageWrapper />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/simulator/launch"
        element={
          <PrivateRoute>
            <Provider>
              <TestSimulatorPageWrapper />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/assistant/launch/:code?"
        element={
          <PrivateRoute>
            <OneDriveRedirect />
          </PrivateRoute>
        }
      />
      <Route
        path="/adduser"
        element={
          <PrivateRoute>
            <Provider>
              <AddUser />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/userupdate"
        element={
          <PrivateRoute>
            <Provider>
              <UpdateUser />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/manageusers"
        element={
          <PrivateRoute>
            <Provider>
              <ManageUsers />
            </Provider>
          </PrivateRoute>
        }
      />
      <Route
        path="/assignuser"
        element={
          <PrivateRoute>
            <Provider>
              <AddUser operation="Manage" />
            </Provider>
          </PrivateRoute>
        }
      />

      <Route
        exact
        path="/pluginbuilder/:projectId?"
        element={
          <PrivateRoute>
            <Provider>
              <PluginBuilder />
            </Provider>
          </PrivateRoute>
        }
      />

      <Route
        exact
        path="/report/:uuid"
        element={
          <PrivateRoute>
            <Provider>
              <HistoryDownload />
            </Provider>
          </PrivateRoute>
        }
      />

      <Route
        exact
        path="/linkedassistants/:folderId"
        element={
          <PrivateRoute>
            <Provider>
              <LinkedAssistants />
            </Provider>
          </PrivateRoute>
        }
      />

      <Route
        exact
        path="/"
        element={
          <RouteWrapper>
            <SignIn />
          </RouteWrapper>
        }
      />
      <Route
        exact
        path="/sso"
        element={
          <RouteWrapper>
            <SsoValidation />
          </RouteWrapper>
        }
      />
      {/* <Route
        exact
        path="/Auto"
        element={
          <RouteWrapper>
            <AutoSignIn />
          </RouteWrapper>
        }
      /> */}
      <Route
        exact
        path="/forgot-password"
        element={
          <RouteWrapper>
            <ForgotPassword setEmail={setEmail} />
          </RouteWrapper>
        }
      />
      <Route
        exact
        path="/sent-mail"
        element={
          <RouteWrapper>
            <SentMail email={email} />
          </RouteWrapper>
        }
      />
      <Route
        exact
        path="/reset-password"
        element={
          <RouteWrapper>
            <ResetPassword />
          </RouteWrapper>
        }
      />
      <Route
        exact
        path="/dashboard/listassistants"
        element={
          <PrivateRoute>
            <ListAssistants />
          </PrivateRoute>
        }
      />
      {Auth.isPathValid([
        "/dashboard/workflow",
        "/dashboard/workflow-builder",
      ]) && (
        <>
          <Route
            path="/dashboard/workflow"
            element={
              <PrivateRoute>
                <WorkflowPageWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/workflow-builder/:uuid?"
            element={
              <PrivateRoute>
                <WorkFlowBuilder />
              </PrivateRoute>
            }
          />
          <Route
            path="/organization"
            element={
              <PrivateRoute>
                <Provider>
                  <OrganizationListPage />
                </Provider>
              </PrivateRoute>
            }
          />
          <Route
            path="/addorg/:id?"
            element={
              <PrivateRoute>
                {/* <Provider> */}
                <AddOrganization />
                {/* </Provider> */}
              </PrivateRoute>
            }
          />
        </>
      )}
      <Route exact path="/unauthorized" element={<UnAuthorized />} />

      <Route path="*" element={<Navigate to="/unauthorized" replace />} />
    </Routes>
  );
}
